var map = {
	"./leaf-1-night.svg": 5154,
	"./leaf-2-night.svg": 2865,
	"./leaf-3-night.svg": 128,
	"./leaf-4-night.svg": 223,
	"./leaf-5-night.svg": 9510,
	"./leaf-6-night.svg": 3061
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2129;